/* eslint-disable */
export default function buildParams(context, page) {
  const {
    certificate,
    office,
    from,
    to,
    expired_from,
    expired_to,
    issued_from,
    issued_to,
    source,
    sub_certificate: subCertificate,
    search,
    status,
    activities,
    statusTask: taksStatusName,
    priority,
    role,
    internal_status,
    external_status,
    first_reviewer,
    second_reviewer,
    inspector,
    application_reviewer,
    markter,
    filter_type,
    ...restQuery // all remaining query params
  } = context.$route.query;

  const knownKeys = [
    "certificate",
    "sub_certificate",
    "from",
    "to",
    "office",
    "source",
    "status",
    "activities",
    "statusTask",
    "role",
    "priority",
    "search"
  ];

  // Clean selectedItem: remove known keys
  const selectedItem = Object.keys(restQuery)
    .filter(key => !knownKeys.includes(key))
    .reduce((acc, key) => {
      acc[key] = context.$route.query[key];
      return acc;
    }, {});

  const skip = (page - 1) * context.perPage;

  return {
    skip,
    ...(certificate && { certificate }),
    ...(subCertificate && { sub: subCertificate.map(item => item).join(",") }),
    ...(internal_status && {
      internal_status: internal_status.map(item => item).join(",")
    }),
    ...(external_status && {
      external_status: external_status.map(item => item).join(",")
    }),
    ...(first_reviewer && {
      first_reviewer: (Array.isArray(first_reviewer)
        ? first_reviewer
        : String(first_reviewer).split(",")
      )
        .filter(Boolean)
        .join(",")
    }),
    ...(second_reviewer && {
      second_reviewer: (Array.isArray(second_reviewer)
        ? second_reviewer
        : String(second_reviewer).split(",")
      )
        .filter(Boolean)
        .join(",")
    }),
    ...(inspector && {
      inspector: (Array.isArray(inspector)
        ? inspector
        : String(inspector).split(",")
      )
        .filter(Boolean)
        .join(",")
    }),
    ...(application_reviewer && {
      application_reviewer: (Array.isArray(application_reviewer)
        ? application_reviewer
        : String(application_reviewer).split(",")
      )
        .filter(Boolean)
        .join(",")
    }),
    ...(markter && {
      markter: (Array.isArray(markter) ? markter : String(markter).split(","))
        .filter(Boolean)
        .join(",")
    }),
    ...(from && { from }),
    ...(to && { to }),
    ...(expired_from && { expired_from }),
    ...(expired_to && { expired_to }),
    ...(issued_from && { issued_from }),
    ...(issued_to && { issued_to }),
    ...(office && { office_id: office }),
    ...(source && { source }),
    ...(status && { status }),
    ...(activities && { activities }),
    ...(role && { role }),
    ...(taksStatusName && { status: taksStatusName }),
    ...(priority && { priority }),
    ...(search && { search }),
    ...(filter_type && { filter_type }),
    ...selectedItem // Add if needed in API call or logging
  };
}

